import type { FC } from "react";
import { WarningDialog } from "../../../../utils/warningDialogs/WarningDialog";
import type { useGapsApprove } from "./useGapsApprove";

type Props = {
	/** The approval's own warning gates (`useGapsApprove`'s `warnings`). */
	warnings: ReturnType<typeof useGapsApprove>["warnings"];
	/** Backs out of the approval from any gate — nothing is written. */
	onCancel: () => void;
};

/**
 * The gates an approval passes before it writes — the unit's target, agency staff, overtime, daily hours — as the
 * Requests screen's approve raises them (`WarningDialog`). Each confirm goes on to the next gate or the write.
 */
export const GapsApproveWarningDialog: FC<Props> = ({ warnings, onCancel }) => (
	<WarningDialog
		openTargetWarning={warnings.warningState.isTargetWarningOpen}
		openAgencyWarning={warnings.warningState.isAgencyWarningOpen}
		openOvertimeWarning={warnings.warningState.isOvertimeWarningOpen}
		openDailyHoursWarning={warnings.warningState.isDailyHoursWarningOpen}
		overtimeDetails={warnings.warningState.overtimeDetails}
		dailyHoursDetails={warnings.warningState.dailyHoursDetails}
		targetDetails={warnings.warningState.targetDetails}
		longShiftDuration={warnings.longShiftDuration}
		onCancelTarget={onCancel}
		onConfirmTarget={warnings.handleTargetConfirm}
		onCancelAgency={onCancel}
		onConfirmAgency={warnings.handleAgencyConfirm}
		onCancelOvertime={onCancel}
		onConfirmOvertime={warnings.handleOvertimeConfirm}
		onCancelDailyHours={onCancel}
		onConfirmDailyHours={warnings.handleDailyHoursConfirm}
	/>
);
